import { Checkbox as MuiCheckbox, type CheckboxProps as MuiCheckboxProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<Omit<MuiCheckboxProps, 'slots' | 'icon' | 'checkedIcon' | 'indeterminateIcon'>>;

export function Checkbox(props: Props) {
  return <MuiCheckbox {...props} />;
}

export type { Props as CheckboxProps };
